
import strings from '../../eyeguide-localization/strings.canvastestview';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';

const thumbsup = require('../../images/thumbup.png');
const thumbsdown = require('../../images/thumbdown.png');
const STIMULUS_COLOR: string = '#FFFFFF';
const BASELINE_COLOR: string = '#0B68F3';
const TEST_COLOR: string = '#34C849';
const TEST_COLOR_IMPAIRED: string = '#CE0D24';
const FOOTER_TEXT_FONT = '14px Arial';

const TEST_TEXT_FONT = 'bold 14px Arial';
const SCORE_LABEL_FONT = window.innerWidth <= 1280 ? 'Bold 12px Arial' : 'Bold 12px Arial';
const SCORE_TEXT_FONT = 'bold 20px Arial';

export default class CanvasTestView {
    canvas: any;
    baselinedata: any;
    testdata: any;
    stimulusRequired: boolean;
    isTestImpaired: boolean;
    testText: string;
    testScore: string;
    isOldData: boolean;
    isOldDataBaseline: boolean;
    canvasWidth: any;
    canvasHeight: any;
    visualOnly: boolean;

    constructor(canvas: any, baselinedata: any, testdata: any, 
                stimulusRequired: boolean, isTestImpaired: boolean, testText: string,
                testScore: any, isOldData: boolean, isOldDataBaseline: boolean, visualOnly: boolean = false ) {
        this.canvas = canvas;
        this.canvas.width = canvas.width;
        this.canvas.height = canvas.height;
        this.canvasWidth = canvas.width;
        this.canvasHeight = canvas.height;
        this.baselinedata = baselinedata;
        this.testdata = testdata;
        this.stimulusRequired = stimulusRequired;
        this.isTestImpaired = isTestImpaired;
        this.testText = testText;
        this.testScore = testScore;
        this.isOldData = isOldData;
        this.isOldDataBaseline = isOldDataBaseline;
        this.visualOnly = visualOnly;
    }

    public async  setCanvasView() {
        console.log('this.testdata', this.testdata);
        console.log('canvas', this.canvasWidth);
        console.log('isOldData', this.isOldData);
        console.log('isOldDataBaseline', this.isOldDataBaseline);
        console.log('visualOnly', this.visualOnly);

        var canvas = this.canvas;
        // Get the device pixel ratio, falling back to 1.
        var dpr = window.devicePixelRatio || 1;
        // Get the size of the canvas in CSS pixels.
        // var rect = canvas.getBoundingClientRect();
        // Give the canvas pixel dimensions of their CSS
        // size * the device pixel ratio.
        canvas.width = canvas.width * dpr;
        canvas.height = canvas.height * dpr;
        canvas.style.width = this.canvasWidth + 'px';
        canvas.style.height = this.canvasHeight + 'px';
        // alert(canvas.width);        
        // Scale all drawing operations by the dpr, so you
        // don't have to worry about the difference.
        // alert( rect.width );
        canvas.getContext('2d').scale(dpr, dpr);

        this.drawFrame();
        if ( this.stimulusRequired) {
            this.drawStimulus();
        }
        if ( this.baselinedata !== undefined && this.baselinedata.length > 0) {
            this.drawBaseLine();
        }
        if ( !this.stimulusRequired &&  this.testdata !== undefined && 
                                this.testdata.length > 0 ) {
            this.drawProfileTest();
        }

        if (!this.visualOnly) {
            let promise = this.drawHeaderData();
            this.drawFooterData(); 
            return promise;
        } else {
            return Promise.resolve([]);
        }
        
    }

    private drawFrame() {
        const canvas = this.canvas;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = 'black';
        ctx.strokeStyle = 'black';
        ctx.fillRect(0 , 0, this.canvasWidth, this.canvasHeight);
    }

    private drawHeaderData() {
        const top = 15;
        const canvas = this.canvas;
        const ctx = canvas.getContext('2d');
        ctx.lineWidth = 1;
        // draw footer bar
        ctx.fillStyle = 'rgba(51, 51, 51, 0.8)';
        // '#333333CC';
        ctx.strokeStyle = 'rgba(51, 51, 51, 0.8)';
        // '#333333CC';
        let headerHeight = (this.canvasHeight * 0.13);
        let headerWidth = (this.canvasWidth * 0.25) + 24;
        this.roundRect( ctx,
                        this.canvasWidth / 2 - headerWidth / 2 ,
                        top,
                        headerWidth, headerHeight,
                        7, ctx.fillStyle, ctx.strokeStyle );
        
        // draw center line
        ctx.fillStyle = 'black';
        ctx.strokeStyle = 'black';
        ctx.fillRect(this.canvasWidth / 2 - headerWidth / 2, top + headerHeight / 2, headerWidth, 1);
        ctx.fillRect(this.canvasWidth / 2 , top + headerHeight / 2, 1, headerHeight - headerHeight / 2);

        // draw test result thumbs up
        let iconWidth = 20;
        let space = 10;
        ctx.font = TEST_TEXT_FONT;
        let textWidth = ctx.measureText(this.testText).width + iconWidth + space;
        let w = this.canvasWidth;
        // let currentInt = this;
        let promise = new Promise(( resolve: any, reject: any) => {
            let localTextWidth = textWidth;
            let imgd = new Image();
            console.log('this.isTestImpaired', this.isTestImpaired);
            imgd.src = ! this.isTestImpaired ? thumbsup : thumbsdown;
            imgd.onload = function() {
                
                ctx.drawImage(imgd, (w / 2) - localTextWidth / 2 , top + 10, iconWidth, iconWidth);
                console.log('image loaded');
                resolve();
            };
        });
        
        // draw score label
        ctx.font = SCORE_LABEL_FONT;
        ctx.fillStyle = '#FFFFFF';
        let text: string = this.stimulusRequired ? strings.lsBaselineScore : strings.lsTestScore;
        textWidth = ctx.measureText(text).width;
        
        ctx.fillText(   text, 
                        w / 2 - headerWidth / 2 + (headerWidth / 2 - textWidth) / 2 , 
                        top + headerHeight / 4 * 3 + 5 );

        // draw test text
        ctx.font = TEST_TEXT_FONT;
        textWidth = ctx.measureText(this.testText).width  + iconWidth + space;
        ctx.fillStyle = this.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR;
        ctx.fillText( this.testText, w / 2 - textWidth / 2  + iconWidth + space, top + 25 );

        // draw score 
        ctx.font = SCORE_TEXT_FONT;
        textWidth = ctx.measureText(this.testScore).width;
        ctx.fillText(   this.testScore, 
                        w / 2 + (headerWidth / 2 - textWidth) / 2 ,  
                        top + headerHeight / 4 * 3 + 7 );
        staticProperties.set(STATICKEYS.testViewLoading, false);
        return promise;
    }

    private drawFooterData() {
        const canvas = this.canvas;
        const ctx = canvas.getContext('2d');
        ctx.lineWidth = 1;
        // draw footer bar
        ctx.fillStyle = '#333333';
        let footerHeight = (this.canvasHeight * 0.075);
        ctx.fillRect(0, this.canvasHeight - footerHeight, this.canvasWidth, footerHeight );

        // Draw Footer
        // Text to display
        ctx.font = FOOTER_TEXT_FONT;
        let txt = this.stimulusRequired ? strings.lsStimulusTxt + '          ' + strings.lsBaselinext 
            : strings.lsBaselinext + '          ' + strings.lsCurrentTestxt; 
        let txtFirst = this.stimulusRequired ? strings.lsStimulusTxt : strings.lsBaselinext; 
        let txtSecond = this.stimulusRequired ? strings.lsBaselinext : strings.lsCurrentTestxt; 
        let entireTextWidth = ctx.measureText(txt).width + 55;
        let firstTextWidth = ctx.measureText(txtFirst).width + 55;

        // draw footer text left
        ctx.fillStyle = this.stimulusRequired ? STIMULUS_COLOR : BASELINE_COLOR;
        let textWidth = entireTextWidth;
        let textHeight = ctx.measureText(txtFirst).height === undefined ? 0 : ctx.measureText(txtFirst).height;
        let centerx = this.canvasWidth / 2 - textWidth / 2;
        let centery = this.canvasHeight - footerHeight +  (footerHeight - textHeight) / 2 + 5;
        console.log('centerx' , centerx);
        console.log('centery', ctx.measureText(txtFirst));
        ctx.fillText( txtFirst, centerx + 16 , centery );

        // draw circle
        let circleRadius = 5;
        ctx.beginPath();
        ctx.arc( centerx + circleRadius, centery - circleRadius, circleRadius , 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.strokeStyle = ctx.fillStyle;
        ctx.stroke();

        // draw footer text right
        ctx.fillStyle = this.stimulusRequired ? BASELINE_COLOR :
                        this.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR;
        ctx.fillText( txtSecond, centerx + firstTextWidth + 16 , centery );

        // draw circle
        ctx.beginPath();
        ctx.arc( centerx + firstTextWidth + circleRadius, centery - circleRadius, circleRadius , 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.strokeStyle = ctx.fillStyle;
        ctx.stroke();
    }

    private drawStimulus() {
        const canvas = this.canvas;
        let centerx = this.canvasWidth / 2;
        let centery = this.canvasHeight / 2;
        const ctx = canvas.getContext('2d');
        let frameangle = -Math.PI;
        let framecount = 0;
        let top = 7 * 60.0 / 2;
        let factor = Math.min(  this.canvasWidth / 1.5, this.canvasHeight / 1.5);
        ctx.strokeStyle = STIMULUS_COLOR; 
        ctx.lineWidth = 10;
        ctx.translate(centerx, centery);
        ctx.beginPath();
        while (true) {
            let x = 0;
            let y = 0;
            if (frameangle < -Math.PI / 2 || frameangle > Math.PI / 2) {
                    x = -Math.cos(2 * frameangle) - 1;
                    y = Math.sin(2 * frameangle);
            } else {
                    x = Math.cos(2 * frameangle) + 1;
                    y = Math.sin(2 * frameangle);
            }
            if ( framecount === 0) {
                ctx.moveTo(x * factor / 2.0, y * factor / 2.0);
            } else {
                ctx.lineTo(x * factor / 2.0, y * factor / 2.0);
            }

            frameangle += Math.PI / top;
            if (frameangle > Math.PI) {
                frameangle = -Math.PI;
            } 
            ++framecount;
            if (framecount >= 60 * 10) {
                    break;
            }
        }
        ctx.stroke();
        ctx.closePath();
        // ctx.resetTransform();
        ctx.translate(-centerx, -centery);
    }

    private drawBaseLine() {
        this.isOldDataBaseline ?
        this.drawTest_old(this.baselinedata, BASELINE_COLOR)
        :
        this.drawTest( this.baselinedata, BASELINE_COLOR);
    }

    private drawProfileTest() {
        this.isOldData ?
        this.drawTest_old(this.testdata, this.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR) :
        this.drawTest( this.testdata, this.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR);

    }

    private drawTest(data: any, color: any) {
        const canvas = this.canvas;
        const ctx = canvas.getContext('2d');
        ctx.save();
        // let { xmean, ymean } = this.mean(data);
        let xmean = 1024 / 2;
        let ymean = 768 / 2;
        let width: number = this.canvasWidth;
        let height: number = this.canvasHeight;
        console.log('width', width);
        console.log('height', height);
        let centerx = width / 2;
        let centery = height / 2;
        ctx.strokeStyle = color;
        ctx.translate(centerx, centery);
        // let scalex = centerx / xmean;
        // let scaley = centery / ymean;
        let scalex = width / 1024;
        let scaley = height / 768;
        // ctx.scale( scalex * .79, scaley * .78 );
        ctx.scale( scalex, scaley );
        xmean = xmean + 5;
        ymean = ymean + 5;
        console.log( window.devicePixelRatio );
        // ctx.rotate(20 * Math.PI / 180.0 , 20 * Math.PI / 180);
        // let bb = this.findboundingbox(data);
                
        // xmean = (bb.right - bb.left) / 2 - 5;
        // ymean = (bb.bottom - bb.top) / 2 + 128;
        
        ctx.lineWidth = color === BASELINE_COLOR ? 3 : 3;
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo( (data[0].x - xmean), (data[0].y - ymean ) );
        // ctx.lineTo( (data[0].x - xmean), (data[0].y - ymean));
        // ctx.ellipse((data[0].x - xmean), (data[0].y - ymean), 2 , 2 , 0 , 0, 2 * Math.PI); 
        ctx.stroke(); 
        
        data.forEach( (element: any) => {
            ctx.moveTo((element.x - xmean), (element.y - ymean));
            // ctx.fillRect(prevX, prevY, (element.x - xmean), (element.y - ymean));
            // ctx.moveTo((element.x - xmean), (element.y - ymean));
            // ctx.lineWidth = 4;
            // ctx.ellipse((element.x - xmean), (element.y - ymean), 4 , 4 , 0 , 0, 2 * Math.PI); 
            // ctx.ellipse((element.x - xmean), (element.y - ymean), 2 , 2 , 0 , 0, 2 * Math.PI); 
            ctx.arc( (element.x - xmean), (element.y - ymean), 2 , 0, 2 * Math.PI);
          });
        ctx.stroke();
        ctx.lineWidth = 7;
        let prevX = data[0].x - xmean;
        let prevY = data[0].y - ymean;
        data.forEach( (element: any) => {
            
            // ctx.lineTo( (element.x - xmean), (element.y - ymean));
            ctx.moveTo(prevX, prevY);
            ctx.lineTo( (element.x - xmean), (element.y - ymean));
            prevX = element.x - xmean;
            prevY = element.y - ymean;
            // ctx.arc( (element.x - xmean), (element.y - ymean), 2 , 0, 2 * Math.PI, false);
        });
        
        // ctx.closePath();
        ctx.stroke();
        
        // ctx.resetTransform();  
        // ctx.scale(1 / scalex, 1 / scaley);  
        // ctx.translate(-centerx, -centery);
        ctx.restore();
    }

    private roundRect(ctx: any, x: any, y: any, width: any, height: any, radius: any, fill: any, stroke: any) {
        
        if (typeof stroke === 'undefined') {
          stroke = true;
        }
        
        if (typeof radius === 'undefined') {
          radius = 5;
        }
        
        if (typeof radius === 'number') {
          radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
          radius = {tl: 0, tr: 0, br: 0, bl: 0};
        }

        ctx.beginPath();
        ctx.moveTo(x + radius.tl, y);
        ctx.lineTo(x + width - radius.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ctx.lineTo(x + width, y + height - radius.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ctx.lineTo(x + radius.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ctx.lineTo(x, y + radius.tl);
        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
        ctx.closePath();
        if (fill) {
          ctx.fill();
        }
        if (stroke) {
          ctx.stroke();
        }      
      }

      private drawTest_old(data: any, color: any) {
        console.log('drawTest_old');
        const canvas = this.canvas;
        const ctx = canvas.getContext('2d');
        ctx.save();
        let { xmean, ymean } = this.mean(data);
        let width: number = this.canvasWidth;
        let height: number = this.canvasHeight;
        let centerx = width / 2;
        let centery = height / 2;
        ctx.strokeStyle = color;
        ctx.translate(centerx, centery);
        let scalex = centerx / xmean;
        let scaley = centery / ymean;
        ctx.scale( scalex * 7 , scaley * 23);
        // xmean = 0;
        // ymean = 0;
        console.log( window.devicePixelRatio );
        // ctx.rotate(20 * Math.PI / 180.0 , 20 * Math.PI / 180);
        /* let bb = this.findboundingbox(data);
                
        xmean = bb.left - (bb.right - bb.left) / 2;
        ymean = bb.top - (bb.bottom - bb.top) / 2;
        */
        ctx.lineWidth = 0.2;
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo( (data[0].x - xmean), (data[0].y - ymean ) );
        // ctx.lineTo( (data[0].x - xmean), (data[0].y - ymean));
        // ctx.ellipse((data[0].x - xmean), (data[0].y - ymean), 0.1 , 0.1 , 0 , 0, 2 * Math.PI); 
        ctx.stroke(); 
        
        data.forEach( (element: any) => {
            ctx.lineTo( (element.x - xmean), (element.y - ymean));
            // ctx.ellipse((element.x - xmean), (element.y - ymean), 0.1 , 0.1 , 0 , 0, 2 * Math.PI); 
            // ctx.arc( (element.x - xmean), (element.y - ymean), 0.1 , 0, 2 * Math.PI, false);
        });
        
        // ctx.closePath();
        ctx.stroke();
        // ctx.resetTransform();
        // ctx.scale(1 / (scalex * 7.0), 1 / (scaley * 23.0));  
        // ctx.translate(-centerx, -centery); 
        ctx.restore();       
    }

    private mean(numbers: Array<any>) {
        let totalx = 0;
        let totaly = 0;

        for (let i = 0; i < numbers.length; i += 1) {
            totalx += numbers[i].x;
            totaly += numbers[i].y;
        }
        return { xmean: totalx / numbers.length, ymean: totaly / numbers.length };
    }

    //  private findboundingbox(numbers: Array<any>) {
    //     let minx = 999999, maxx = -1, miny = 999999, maxy = -1;
    //     for (let i = 0; i < numbers.length; i += 1) {
    //         minx = Math.min( minx, numbers[i].x );
    //         maxx = Math.max( maxx, numbers[i].x );
    //         miny = Math.min( miny, numbers[i].y );
    //         maxy = Math.max( maxy, numbers[i].y );
    //     }
    //     return { left: minx, top: miny, right: maxx, bottom: maxy };
    // }

}


// WEBPACK FOOTER //
// ./src/components/common/canvasTestView.tsx